import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import { useAtom } from 'jotai'
import styled from 'styled-components'
import { rwDeleteDialogAtom } from '../../atoms/Delete'
import { useToasts } from '@geist-ui/react'

const OuterDiv = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 25px;
`

const Title = styled.div`
  color: white;
  font-size: 20px;
  font-weight: 500;
  white-space: pre;
`

const ButtonsDiv = styled.div`
  display: flex;
  flex-direction: row;
`

const CancelButton = styled.div`
  color: white;
  padding: 5px 15px;
  font-weight: 400;
  margin-top: 15px;
  font-size: 18px;
  cursor: pointer;
`

const DeleteButton = styled.div`
  margin-left: 15px;
  border-color: #ff453a;
  border-width: 2px;
  border-style: solid;
  color: #ff453a;
  border-radius: 10px;
  padding: 5px 15px;
  font-weight: 600;
  margin-top: 15px;
  font-size: 18px;
  cursor: pointer;
`

const BACKDROP_PROPS = {
  style: {
    backdropFilter: 'blur(20px)',
  },
}

const DeleteCommentDialog = (): JSX.Element => {
  const [comment, setComment] = useAtom(rwDeleteDialogAtom)
  const [, setToast] = useToasts()

  return (
    <Dialog
      onClose={() => setComment(null)}
      aria-labelledby="delete-dialog"
      open={!!comment}
      PaperProps={{
        style: {
          backgroundColor: '#101010',
          borderRadius: 30,
          //   minWidth: isTablet ? '75vw' : '75vh',
          //   minHeight: isTablet ? '75vw' : '75vh',
          //   height: !fullscreen ? (isTablet ? '75vw' : '75vh') : '',
        },
      }}
      BackdropProps={BACKDROP_PROPS}
    >
      <OuterDiv>
        <Title>{`Are you sure you want to delete\nyour ${
          comment?.reply_id ? 'reply' : 'comment'
        }?`}</Title>
        <ButtonsDiv>
          <CancelButton onClick={() => setComment(null)}>Cancel</CancelButton>
          <DeleteButton
            onClick={() => {
              comment?.delete(comment.comment_id, comment.reply_id)
              setComment(null)
              setToast({
                text: `${comment?.reply_id ? 'Reply' : 'Comment'} deleted.`,
                type: 'default',
              })
            }}
          >
            Delete
          </DeleteButton>
        </ButtonsDiv>
      </OuterDiv>
    </Dialog>
  )
}

export default DeleteCommentDialog
